import * as Constants from '../../constants'


let years = calculateYears();



let selectBuilderImpl = {
    'registrar.year':yearSelectBuilderImpl,
    'registrar.area':areaSelectBuilderImpl,
    'registrar.zone':zoneSelectBuilderImpl,
    'registrant.edu': domainSelectBuilderImpl,
    'registrant.zone':zoneSelectBuilderImpl,
    'registrant.area':areaSelectBuilderImpl,
    'registrant.region':regionSelectBuilder,
    'registrant.registrant':registrantSelectBuilder,
}



function calculateYears() {

  let yearParams = {};
  //let selectedYear = selection.target.value;
  let startYear = 2012;
  yearParams["all"] = {start:'2012-01-01',end:dateString()};

  let thisYear = (new Date()).getFullYear();
  yearParams["2012"] = {start:"2012-01-01", end:"2012-12-31"};
  for (let year=startYear+1;year<=thisYear;year++) {
    yearParams[year]={start:(year-1)+"-12-31", end:year+"-12-31"}
  }
  return yearParams;
  // console.dir(yearParams);
}

function getQueryValue(queryString) {
  let parts = queryString.split('.');
  return parts[parts.length-1];
}


export function isEmpty(object) {
  return (Object.keys(object).length === 0 && object.constructor === Object);
}

export function selectBuilder(selectKind, operation, state,query,props, formatMessage) {
  return selectBuilderImpl[selectKind](operation, state,query,props,formatMessage);
}

function registrantSelectBuilder(operation, state,query,props, formatMessage) {
  let registrantItems = [];
  if (query && !(Object.keys(query).length === 0) && (query['zone']!=='all')) {
    let zoneIdx = query['zone'];
    let areaIdx = query['area'];
    let eduIdx = query['edu'];

    let registrantValues = null;

    if (zoneIdx ==='italy') {
        if (eduIdx === 'no') {
            registrantValues = Constants.ITALY_REGISTRANTS;
        } else {
            if (eduIdx === 'only') {
                registrantValues = Constants.ITALY_EDU_REGISTRANTS;
            }
        }
    } else {
        if (!eduIdx || eduIdx === 'no') {
            if (areaIdx && (areaIdx === 'eu-west' || areaIdx === 'eu-east' || areaIdx === 'eu-south' || areaIdx === 'eu-north'))
                registrantValues = Constants.EU_REGISTRANTS;
        }
    }

    if (registrantValues) {
      registrantValues.forEach(function(selection, i) {
        registrantItems.push({key:i, value:selection, item:formatMessage({id:selection})});
      })
    }

  }

  return registrantItems;
}


function regionSelectBuilder(operation, state,query,props, formatMessage) {
  let regioniItems = [];
  if (query && !(Object.keys(query).length === 0) && (query['zone'] ==='italy') && query['area']) {
    let areaValue = query['area'];

    if (areaValue !== 'all') {
     regioniItems.push({key:0, value:'region.all', item:formatMessage({id:'region.all'})});

     Constants.REGIONS[areaValue].forEach(function(regione,i) {
         regioniItems.push({key:i+1, value:'region.'+regione, item:formatMessage({id:regione})});
     })
   }
  }
  return regioniItems;
}




function yearSelectBuilderImpl(operation, state,query,props, formatMessage) {
  let yearItems = [];


  if (operation === 'growth') {

    let firstYear = 2012;
    let thisYear = new Date();
    thisYear = thisYear.getFullYear();
    let i;

    yearItems.push({key:0, value:'year.all', item:formatMessage({id:'select.allYears'})});

    for (i=thisYear; i>=firstYear; i--) {
      yearItems.push({key:i, value:'year.'+i, item:i});
    }

  }

  return yearItems;
}

function domainSelectBuilderImpl(operation, state, query, props, formatMessage) {
    let domainItems = [];
    domainItems.push({key:0, value:'edu.all', item:formatMessage({id: 'edu.all'})});
    domainItems.push({key:1, value:'edu.no', item:formatMessage({id: 'edu.no'})});
    domainItems.push({key:2, value:'edu.only', item:formatMessage({id: 'edu.only'})});
    return domainItems;
}

function areaSelectBuilderImpl(operation, state,query,props, formatMessage) {
  let areaItems = [];
  if (query && !(Object.keys(query).length === 0)) {
      let values = [];
      if (query['zone'] !== 'all') {

          switch (query['zone']) {
              case 'italy':
                  values = Constants.IT_AREA;
                  break;
              case 'foreign':
                  values = Constants.FOREIGN_AREA;
                  break;
              default:
                  break;
          }
      }
    values.forEach(function(value,i) {
      areaItems.push({key:i, value:value, item:formatMessage({id:value})});
    })

  }
  return areaItems;
}

function zoneSelectBuilderImpl(operation, state,query,props, formatMessage) {
    let zoneItems = [];
    let domainIdx = query['edu'];
    if (!domainIdx || (domainIdx && domainIdx === 'no')) {
        zoneItems.push({key:0, value:'zone.all', item:formatMessage({id:'zone.all'})});
        zoneItems.push({key:1, value:'zone.italy', item:formatMessage({id:'zone.italy'})});
        zoneItems.push({key:2, value:'zone.foreign', item:formatMessage({id:'zone.strangers'})});

    } else {
        if (domainIdx === 'only') {
            zoneItems.push({key:1, value:'zone.italy', item:formatMessage({id:'zone.italy'})});
        }
    }

  return zoneItems;
}


/*******************************************/
/* SEZIONE HANDLER SELECT                  */
/*******************************************/

export const selectHandler = {
    'registrar.year':yearSelectHandlerImpl,
    'registrar.area':areaSelectHandlerImpl,
    'registrant.edu': domainSelectHandlerImpl,
    'registrar.zone':zoneSelectHandlerImpl,
    'registrant.area':areaSelectHandlerImpl,
    'registrant.zone':zoneSelectHandlerImpl,
    'registrant.region':regionSelectHandlerImpl,
    'registrant.registrant':registrantSelectHandlerImpl
}

function domainSelectHandlerImpl(selection) {
    let newQuery = this.props.location.query;

    let domainType  = selection.target.value;

    // Pulizia delle query

    if (newQuery['edu']) {
        delete newQuery['edu'];
    }

    if (newQuery['area']) {
        delete newQuery['area'];
    }

    if (newQuery['registrant']) {
        delete newQuery['registrant'];
    }

    if (newQuery['region']) {
        delete newQuery['region'];
    }

    if (newQuery['zone']) {
        delete newQuery['zone'];
    }

    let domainValue = null;
    let zoneValue = 'all';

    if (domainType === 'edu.no') {
        domainValue = 'no';

    }

    if (domainType === 'edu.only') {
        domainValue = 'only';
        zoneValue = 'italy';
    }

    if (domainValue) {
        Object.assign(newQuery, {edu: domainValue, zone: zoneValue})
    } else {
        Object.assign(newQuery, {zone: zoneValue});
    }

    this.context.router.push({pathname: this.props.location.pathname, query: newQuery});
}


function registrantSelectHandlerImpl(selection) {
  let newQuery = this.props.location.query;

  let registrantValue = getQueryValue(selection.target.value);


  // Eliminare elemento se presente
  if (newQuery['registrant']) {
      delete newQuery['registrant'];
  }

  if (registrantValue>0)
	    Object.assign(newQuery, {registrant:registrantValue});

  this.context.router.push({pathname:this.props.location.pathname, query:newQuery});
}


function yearSelectHandlerImpl(selection) {
  let newQuery = this.props.location.query;

  let year = getQueryValue(selection.target.value);

  Object.assign(newQuery, {year:year});

  this.context.router.push({pathname:this.props.location.pathname, query:newQuery});

}


/*****************************************/
/* SEZIONE CONFIGURAZIONE CLASSI GRAFICI */
/*****************************************/



const domainChartConfiguration = {
  tabs: [
        {label:'tab.domain.growth', link:'/domain/growth'},
        {label:'tab.domain.registration', link:'/domain/registration'},
        {label:'tab.domain.delete', link:'/domain/delete'},
        {label:'tab.domain.transfer', link:'/domain/transferTotal'},
        {label:'tab.domain.renewal', link:'/domain/renewal'},
        {label:'tab.domain.restore', link:'/domain/restore'},
        {label:'tab.domain.reassign', link:'/domain/reassign'}
    ],
    subtabs: [
      {
        selector:'tab.domain.transfer',
        tabs: [
                {label:'subtab.domain.transferTotal', link:'/domain/transferTotal'},
                {label:'subtab.domain.transfer', link:'/domain/transfer'},
                {label:'subtab.domain.transferWithTrade', link:'/domain/transferWithTrade'},
                {label:'subtab.domain.transferBulk', link:'/domain/transferBulk'},

              ]
      }
    ]
}


const registrarChartConfiguration = {
  query: {
    zone:'all'
  },
  tabs: [
          {label:'tab.registrar.count', link:'/registrar/count'},
          {label:'tab.registrar.registration', link:'/registrar/registration'},
          {label:'tab.registrar.delete', link:'/registrar/delete'},
          {label:'tab.registrar.domain', link:'/registrar/domain'},
          {label:'tab.registrar.transfer', link:'/registrar/transfer_in'},
          {label:'tab.registrar.contract_transfer', link:'/registrar/contract_transfer_in'},
          {label:'tab.registrar.growth', link:'/registrar/growth'}
      ],
  subtabs: [
        {
          selector:'tab.registrar.transfer',
          tabs: [
                  {label:'subtab.registrar.transfer_in', link:'/registrar/transfer_in'},
                  {label:'subtab.registrar.transfer_out', link:'/registrar/transfer_out'}
                ]
        },
        {
          selector:'tab.registrar.contract_transfer',
          tabs: [
                  {label:'subtab.registrar.contract_transfer_in', link:'/registrar/contract_transfer_in'},
                  {label:'subtab.registrar.contract_transfer_out', link:'/registrar/contract_transfer_out'}
                ]
        }
      ],
  filters: ['year', 'zone', 'area'],
  options: {

      zoneSelectionMap: {
        "all": null, // Tutte le zone
        "italy": Constants.IT_AREA, // Italia
        "foreign": Constants.FOREIGN_AREA, // Estero
      },

      zoneSelectQuery: {
        "zone.all": "all",
        "zone.italy": "italy",
        "zone.foreign": "foreign"
      },

      areaSelectionQuery: {
        'area.italy.all':"all", // Zone Italy: All Areas
        'area.nord':"nord", // Zone Italy: Nord
        'area.centro':"centro", // Zone Italy: Center
        'area.sud':"sud", // Zone Italy: South
        'area.all.foreign':'all',
        'area.africa':'africa',
        'area.antartica':'antartica',
        'area.americas':'americas',
        'area.asia':'asia',
        'area.oceania':'oceania',
        'area.eu-east':'eu-east',
        'area.eu-north':'eu-north',
        'area.eu-south':'eu-south',
        'area.eu-west':'eu-west'

      },
  },
  queryParams: {
    'zone': {
        'all': {groupby:'zone'},
        'italy': {zone:'italy', groupby:'area'},
        'foreign': {zone:'foreign', groupby:'continent'}
      },
    'area': {
        'all': {groupby:'area'},
        'nord':{zone:'italy', area:'nord', groupby:'region'},
        'sud':{zone:'italy', area:'sud', groupby:'region'},
        'centro': {zone:'italy', area:'centro', groupby:'region'},
        'africa':{zone:'foreign',area:'africa',  groupby:'country'},  // Zone: Foreign, Area: Africa
        "antartica":{zone:'foreign',area:'antartica', groupby:'country'}, // Zone: Foreign, Area: Antartica
        "americas":{zone:'foreign',area:'americas', groupby:'country'}, // Zone: Foreign, Area Americas          
        "asia":{zone:'foreign',area:'asia', groupby:'country'}, // Zone: Foreign, Area Asia
        "oceania":{zone:'foreign',area:'oceania', groupby:'country'}, // Zone: Foreign, Area: Oceania
        "eu-east":{zone:'foreign',area:'eu-east', groupby:'country'}, // Zone: Foreign, Area: EAST Europe
        "eu-north":{zone:'foreign',area:'eu-north', groupby:'country'}, // Zone: Foreign:, Area: NORTH Europe
        "eu-south":{zone:'foreign',area:'eu-south', groupby:'country'}, // Zone: Foreign, Area: SOUTH Europe
        "eu-west":{zone:'foreign', area:'eu-west', groupby:'country'}
      },
    'year': years
  }
}



const registrantChartConfiguration = {
  query: {
    zone:'italy'
  },
  tabs:  [
      {label:'tab.registrant.registration', link:'/registrant/registration'},
      {label:'tab.registrant.delete', link:'/registrant/delete'},
      {label:'tab.registrant.transfer', link:'/registrant/transferTotal'},
      {label:'tab.registrant.restore', link:'/registrant/restore'},
      {label:'tab.registrant.renewal', link:'/registrant/renewal'},
    ],
  subtabs:  [
    {
      selector: 'tab.registrant.transfer',
      tabs: [
              {label:'subtab.registrant.transferTotal', link:'/registrant/transferTotal'},
              {label:'subtab.registrant.transfer', link:'/registrant/transfer'},
              {label:'subtab.registrant.transferWithTrade', link:'/registrant/transferWithTrade'}
            ]
    }
  ],

  filters: [ 'edu', 'zone', 'area', 'region','registrant'],
    queryParams: {
      'edu': {
          "no": {edu:'no'},
          "only": {edu:'only'}
      },
      'region': {
        "Piemonte": {region:'Piemonte',groupby:'province'},
        "Emilia-Romagna": {region:'Emilia-Romagna',groupby:'province'},
        "Friuli-Venezia Giulia":{region:'Friuli-Venezia Giulia',groupby:'province'},
        "Liguria":{region:'Liguria',groupby:'province'},
        "Lombardia":{region:'Lombardia', groupby:'province'},
        "Trentino-Alto Adige":{region:'Trentino-Alto Adige', groupby:'province'},
        "Valle d'Aosta":{region:"Valle d'Aosta", groupby:'province'},
        "Veneto":{region:"Veneto", groupby:'province'},
        "Lazio":{region:"Lazio", groupby:'province'},
        "Marche":{region:"Marche", groupby:'province'},
        "Toscana":{region:"Toscana", groupby:'province'},
        "Umbria":{region:"Umbria", groupby:'province'},
        "Abruzzo":{region:"Abruzzo", groupby:'province'},
        "Basilicata":{region:"Basilicata", groupby:'province'},
        "Calabria":{region:"Calabria", groupby:'province'},
        "Campania":{region:"Campania", groupby:'province'},
        "Molise":{region:"Molise", groupby:'province'},
        "Puglia":{region:"Puglia", groupby:'province'},
        "Sardegna":{region:"Sardegna", groupby:'province'},
        "Sicilia":{region:"Sicilia", groupby:'province'},
      },
      'registrant': {
        '0':{registrant:'0'},
        '1':{registrant:'1'},
        '2':{registrant:'2'},
        '3':{registrant:'3'},
        '4':{registrant:'4'},
        '5':{registrant:'5'},
        '6':{registrant:'6'},
        '7':{registrant:'7'},
      },
      'zone': {
        'all': {groupby:'zone'},
        'italy': {zone:'italy', groupby:'area'},
        'foreign': {zone:'foreign', groupby:'continent'}
      },
      'area': {
        'all': {groupby:'area'},
        'nord':{zone:'italy', area:'nord', groupby:'region'},
        'sud':{zone:'italy', area:'sud', groupby:'region'},
        'centro': {zone:'italy', area:'centro', groupby:'region'},
        'africa':{zone:'foreign',area:'africa',  groupby:'country'},  // Zone: Foreign, Area: Africa
        "antartica":{zone:'foreign',area:'antartica', groupby:'country'}, // Zone: Foreign, Area: Antartica
        "americas":{zone:'foreign',area:'americas', groupby:'country'}, // Zone: Foreign, Area Americas
        "asia":{zone:'foreign',area:'asia', groupby:'country'}, // Zone: Foreign, Area Asia
        "oceania":{zone:'foreign',area:'oceania', groupby:'country'}, // Zone: Foreign, Area: Oceania
        "eu-east":{zone:'foreign',area:'eu-east', groupby:'country'}, // Zone: Foreign, Area: EAST Europe
        "eu-north":{zone:'foreign',area:'eu-north', groupby:'country'}, // Zone: Foreign:, Area: NORTH Europe
        "eu-south":{zone:'foreign',area:'eu-south', groupby:'country'}, // Zone: Foreign, Area: SOUTH Europe
        "eu-west":{zone:'foreign', area:'eu-west', groupby:'country'}
      }
    },
    options: {
      zoneSelectQuery: {
        "zone.all": "all",
        "zone.italy": "italy",
        "zone.foreign": "foreign"
      },

      areaSelectionQuery: {
        'area.italy.all':"all", // Zone Italy: All Areas
        'area.nord':"nord", // Zone Italy: Nord
        'area.centro':"centro", // Zone Italy: Center
        'area.sud':"sud", // Zone Italy: South
        'area.all.foreign':'all',
        'area.africa':'africa',
        'area.antartica':'antartica',
        'area.americas':'americas',
        'area.asia':'asia',
        'area.oceania':'oceania',
        'area.eu-east':'eu-east',
        'area.eu-north':'eu-north',
        'area.eu-south':'eu-south',
        'area.eu-west':'eu-west'
      },
    }
}



export const chartComponentConfiguration = {
  "domain": domainChartConfiguration,
  "registrar":registrarChartConfiguration,
  "registrant": registrantChartConfiguration
}


// Le chiavi delle query vengono gestite in ordine alfabetico. La struttura dati
// forza un ordine

export const queryKeyOrder = {
  "registrant": {
    "registration": ['edu', 'zone', 'area','registrant', 'region'],
     "delete":['edu', 'zone', 'area', 'registrant', 'region'],
     "transfer":['edu', 'zone', 'area', 'registrant','region'],
     "transferWithTrade":['edu', 'zone', 'area', 'registrant','region'],
     "transferTotal":['edu', 'zone', 'area', 'registrant','region'],
     "renewal": ['edu', 'zone', 'area', 'year','region', 'registrant'],
     "restore": ['edu', 'zone', 'area', 'year','region', 'registrant'],
  },
  "registrar": {
    "registration": ['zone', 'area'],
    "domain":['zone', 'area'],
    "delete":['zone', 'area'],
    "transfer_in":['zone', 'area'],
    "transfer_out":['zone', 'area'],
    "growth":['zone', 'area', 'year'],
    "contract_transfer_in": ['zone', 'area'],
    "contract_transfer_out": ['zone', 'area'],
    "count": ['zone', 'area'],
  },
}

export function dateString() {
    let currentDate = new Date();

    let myDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), (currentDate.getDate()-currentDate.getDate()));
    let myMonth=((myDate.getMonth()+1)<10)?'0'+(myDate.getMonth()+1):(myDate.getMonth()+1);

    return myDate.getFullYear()+"-"+myMonth+"-"+myDate.getDate();
}



function areaSelectHandlerImpl(selection) {
  let newQuery = this.props.location.query;

  // Pulizia
  if (newQuery['area']) {
    delete newQuery['area'];
  }

  if (newQuery['region']) {
    delete newQuery['region'];
  }


  Object.assign(newQuery, {area:chartComponentConfiguration[this.props.params.kind].options.areaSelectionQuery[selection.target.value]})

  this.context.router.push({pathname:this.props.location.pathname, query:newQuery});

}

function zoneSelectHandlerImpl(selection) {
  let newQuery = this.props.location.query;

  // Pulizia

  if (newQuery['area']) {
    delete newQuery['area'];
  }


  if (newQuery['registrant']) {
    delete newQuery['registrant'];
  }

  if (newQuery['region']) {
    delete newQuery['region'];
  }


  Object.assign(newQuery, {zone:chartComponentConfiguration[this.props.params.kind].options.zoneSelectQuery[selection.target.value]})
  this.context.router.push({pathname:this.props.location.pathname, query:newQuery});
}


function regionSelectHandlerImpl(selection) {

  let newQuery = this.props.location.query;

  if (newQuery['region']) {
    delete newQuery['region'];
  }

  let regionValue = getQueryValue(selection.target.value);

  Object.assign(newQuery, {region:regionValue});

  this.context.router.push({pathname:this.props.location.pathname, query:newQuery});

}



// WEBPACK FOOTER //
// ./src/components/charts/ChartComponentUtils.js